function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextInput } from "@brandwatch/axiom-components";
import { translate } from "@brandwatch/axiom-localization";
const t = translate({
  "Sorry, your password confirmation doesn't match": {
    de: "Entschuldigung, Ihre Passwortbestätigung stimmt nicht überein",
    es: "Lo sentimos, la confirmación de la contraseña no coincide",
    fr: "Désolé, votre confirmation de mot de passe ne correspond pas"
  },
  "Confirm new password": {
    de: "Neues Passwort bestätigen",
    es: "Confirmar nueva contraseña",
    fr: "Confirmez votre nouveau mot de passe"
  }
});
export default class ConfirmPasswordInput extends Component {
  render() {
    const {
      axiomLanguage
    } = this.context;
    const {
      passwordValue,
      value,
      ...rest
    } = this.props;
    return /*#__PURE__*/React.createElement(TextInput, _extends({}, rest, {
      error: () => t("Sorry, your password confirmation doesn't match", axiomLanguage),
      label: t("Confirm new password", axiomLanguage),
      patterns: [value => value === passwordValue],
      required: true,
      space: "x8",
      type: "password",
      value: value
    }));
  }

}

_defineProperty(ConfirmPasswordInput, "contextTypes", {
  axiomLanguage: PropTypes.string
});